import React, { useState } from "react"

import { Col, Container, Row } from "react-bootstrap"
import playstore from "../../assets/img/badge_googleplay.svg"
import appstore from "../../assets/img/badge_appstore.svg"
import myploscreen from "../../assets/img/footerBatch.png"
import emtycard from "../../assets/images/nodataGif.gif"
// import searchEmpty from "../../assets/img/search-empty.jpg"
import searchEmpty from "../../assets/images/nodata.png"
import nodataGif from "../../assets/images/no-new.png"
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import "react-input-range/lib/css/index.css"
import InputRange from "react-input-range"
import { Checkbox, FormControlLabel } from "@mui/material"
import { useEffect } from "react"
import { APICALL } from "helper/api/api"
import { defaultIMG, imgBaseURL } from "helper/Utility"
import FrontPageLoader from "helper/my-com/FrontPageLoader"
import ProductBox from "views/Component/ProductBox"
import AppPlayStore from "views/Component/AppPlayStore"
import { useFrontDataContext } from "helper/context/FrontContextProvider"
import SellYourPartyleftover from "views/Component/SellYourPartyleftover"

const ProductListing = () => {
    const { id } = useParams()
    const [open, setOpen] = useState(false)
    const [searchParams] = useSearchParams()
    const location = searchParams.get("location")
    const keyword = searchParams.get("keyword")
    const latitude = searchParams.get("latitude")
    const longitude = searchParams.get("longitude")
    const { contextLoader, getCategoryListFunc, categoryList } = useFrontDataContext()
    const [isPaneOpen, setIsPaneOpen] = React.useState(false)

    const [value, setValue] = useState({ min: 0, max: 30 })
    const [categoryData, setCategoryData] = useState(null)
    const [SubCategories, setSubCategories] = useState([])
    const [productList, setProductList] = useState([])
    const [loading, setLoading] = useState(false)
    const [conditions, setConditions] = useState(["Excellent", "Good", "Fair"])
    const [deliveryMethod, setDeliveryMethod] = useState(["partyHandOff", "partyInABox", "mixAndMatch"])
    const [filtersubcategories, setFilteredSubcategories] = useState([])
    const [isFilterApply, setIsFilterApple] = useState(false)

    const navigate = useNavigate()
    const handleOptionClick = (option) => {
        setOpen(false)
        // Here you can trigger your backend API or navigation logic
        if (option == "SellParty") {
            setIsPaneOpen(true)
        } else if (option == "GoBack") {
            navigate(`/categories`)
        }
    }

    useEffect(() => {
        if (id) {
            getSubCategoryListFunc(id)
            const initialSubCategories = searchParams.getAll("subCategoryId") || []
            setFilteredSubcategories(initialSubCategories)
            getCategoryListFunc()
            // getProductListFunc(initialSubCategories) // Pass as arg
        }
    }, [])

    const handleConditionChange = (event) => {
        const { name, checked } = event.target
        setConditions((prevConditions) => (checked ? [...prevConditions, name] : prevConditions.filter((condition) => condition !== name)))
    }

    const handleDeliveryMethodChange = (event) => {
        const { name, checked } = event.target
        setDeliveryMethod((prevConditions) => (checked ? [...prevConditions, name] : prevConditions.filter((condition) => condition !== name)))
    }
    const handleSubCategoriesChange = (event) => {
        const { id, checked } = event.target
        setFilteredSubcategories((prevConditions) => (checked ? [...prevConditions, id] : prevConditions.filter((item) => item !== id)))
    }

    const getSubCategoryListFunc = async (id) => {
        try {
            const params = { categoryId: id }
            const apiEnd = "user/getSubcategoryByCategoryId"
            const res = await APICALL(apiEnd, "post", params)
            if (res?.status) {
                const allSubIds = res?.data?.map((sub) => sub._id) || []
                setSubCategories(res?.data)
                setFilteredSubcategories(allSubIds)
                setIsFilterApple(true)

                setTimeout(() => {
                    getProductListFunc(allSubIds)
                }, 0)
            } else {
                setSubCategories([])
                setFilteredSubcategories([])
            }
        } catch (error) {
            setSubCategories([])
            setFilteredSubcategories([])
        } finally {
            setLoading(false)
        }
    }

    const getProductListFunc = async (subCategoryOverride = null) => {
        setLoading(true)
        try {
            const categorySerachParams = {
                categoryId: id,
                condition: conditions,
                deliveryMethod: deliveryMethod,
                subCategoryId: subCategoryOverride || filtersubcategories
            }
            const homeSearchParams = {
                keyword: keyword,
                latitude: latitude,
                longitude: longitude
            }
            const params = id ? categorySerachParams : homeSearchParams
            const apiEnd = id ? "user/getProductsByCategoryId" : "user/getProductsByHomeFilter"
            const res = await APICALL(apiEnd, "post", params)
            if (res?.status) {
                setCategoryData(res?.categoryData)
                setProductList(res?.data)
            } else {
                setProductList([])
            }
        } catch (error) {
            setProductList([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!isFilterApply) {
            getProductListFunc()
        }
    }, [isFilterApply])

    const handlefilter = () => {
        setIsFilterApple(true)
        getProductListFunc()
    }

    const handleClear = () => {
        setConditions(["Excellent", "Good", "Fair"])
        setDeliveryMethod(["partyHandOff", "partyInABox", "mixAndMatch"])
        const allSubIds = SubCategories.map((sub) => sub._id)
        setFilteredSubcategories(allSubIds)
        setIsFilterApple(true)
        getProductListFunc(allSubIds)
    }

    useEffect(() => {
        if (categoryData) {
            document.title = categoryData?.seoTitle || "MyPlo"

            const descriptionMetaTag = document.querySelector("meta[name='description']")
            if (descriptionMetaTag) {
                descriptionMetaTag.setAttribute("content", categoryData?.seoTitle || "MyPlo")
            } else {
                const metaTag = document.createElement("meta")
                metaTag.name = "description"
                metaTag.content = categoryData?.seoTitle || "MyPlo"
                document.head.appendChild(metaTag)
            }

            const keywordsMetaTag = document.querySelector("meta[name='keywords']")
            if (keywordsMetaTag) {
                keywordsMetaTag.setAttribute("content", categoryData?.seoTitle || "default, keywords")
            } else {
                const metaTag = document.createElement("meta")
                metaTag.name = "keywords"
                metaTag.content = categoryData?.seoTitle || "default, keywords"
                document.head.appendChild(metaTag)
            }

            // ✅ Add or Update Canonical Link
            let canonicalLink = document.querySelector("link[rel='canonical']")
            if (canonicalLink) {
                canonicalLink.setAttribute("href", window.location.href)
            } else {
                canonicalLink = document.createElement("link")
                canonicalLink.rel = "canonical"
                canonicalLink.href = window.location.href
                document.head.appendChild(canonicalLink)
            }
        }
    }, [categoryData])

    return (
        <>
            <div className="margindiv-header">
                <section className="prodcuts_listing_page">
                    {loading ? (
                        <FrontPageLoader />
                    ) : (
                        <Container>
                            {id && (
                                <Row>
                                    <Col xl="8" lg="7" md="10">
                                        <div className="myplo-title-h2 d-block">
                                            <h2 className="ps-0 mb-2">
                                                <span className="shape"></span>
                                                {categoryData?.categoryName}
                                            </h2>
                                            <p>{categoryData?.description}</p>
                                        </div>
                                    </Col>
                                </Row>
                            )}

                            <div className="prodcuts_listing_flex mt-2">
                                {id && (
                                    <div className="prodcuts_listing_colleft">
                                        <div className="filertcler">
                                            <p>FILTERS </p>
                                            <button type="button" className="cleBtmn" onClick={() => handleClear()}>
                                                {" "}
                                                Clear Filters
                                            </button>
                                        </div>
                                        <div className="nn_fliterctn px-3">
                                            <label className="d-block mb-2">Condition</label>
                                            <FormControlLabel className="labelName-filter" control={<Checkbox name="Excellent" checked={conditions.includes("Excellent")} onChange={handleConditionChange} />} label="Excellent" />
                                            <FormControlLabel className="labelName-filter" control={<Checkbox name="Good" checked={conditions.includes("Good")} onChange={handleConditionChange} />} label="Good" />
                                            <FormControlLabel className="labelName-filter" control={<Checkbox name="Fair" checked={conditions.includes("Fair")} onChange={handleConditionChange} />} label="Fair" />
                                        </div>

                                        {
                                            SubCategories?.length > 0 &&
                                            <div className="nn_fliterctn px-3">
                                                <label className="d-block mb-2">Sub categories</label>
                                                {SubCategories?.map((item, i) => (
                                                    <FormControlLabel key={i} className="labelName-filter" control={<Checkbox id={item._id} checked={filtersubcategories.includes(item._id)} onChange={handleSubCategoriesChange} />} label={item.categoryName} />
                                                ))}
                                            </div>
                                        }

                                        <div className="nn_fliterctn px-3">
                                            <label className="d-block mb-2">Delivery Method</label>
                                            <FormControlLabel className="labelName-filter" control={<Checkbox name="partyHandOff" checked={deliveryMethod.includes("partyHandOff")} onChange={handleDeliveryMethodChange} />} label="Party Hand-Off" />
                                            <FormControlLabel className="labelName-filter" control={<Checkbox name="partyInABox" checked={deliveryMethod.includes("partyInABox")} onChange={handleDeliveryMethodChange} />} label="Party in a Box" />
                                            <FormControlLabel className="labelName-filter" control={<Checkbox name="mixAndMatch" checked={deliveryMethod.includes("mixAndMatch")} onChange={handleDeliveryMethodChange} />} label="Mix & Match" />
                                        </div>


                                        <div className="border-top pt-2">
                                            <button type="button" className="cmn-btn2 w-100" onClick={() => handlefilter()}>
                                                Filter
                                            </button>
                                        </div>
                                    </div>
                                )}

                                <div className="prodcuts_listing_colright">
                                    {productList?.length > 0 ? (
                                        <div className="row">
                                            {productList?.map((item, i) => (
                                                <div className="col-lg-4 col-md-4 col-sm-6  mb-4" key={i}>
                                                    <ProductBox item={item} />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (

                                        <div className="myplo_notFound">
                                            <img src={nodataGif} alt="empty" style={{ width: "22%" }} />
                                            <h3 class="mt-2"> Looks like the party hasn't started here yet</h3>
                                            <h5 className="mt-2"> {"Want to be the first to post something fabulous?"}</h5>

                                            <div className="action-buttons">
                                                <button className="cmn-btn2 w-100" onClick={() => handleOptionClick("SellParty")}>
                                                    List an Item in This Category
                                                </button>
                                                <button className="cmn-btn2 w-100" onClick={() => handleOptionClick("GoBack")}>
                                                    Back to Browse
                                                </button>
                                            </div>

                                            {!id && (
                                                <Link to={`/`} className="d-block mt-2">
                                                    Back
                                                </Link>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Container>
                    )}
                </section>
                <AppPlayStore />
            </div>
            <SellYourPartyleftover isPaneOpen={isPaneOpen} setIsPaneOpen={setIsPaneOpen} />
        </>
    )
}

export default ProductListing
